// store/modules/cubes.js
import { Auth } from '@/database';

class Column {
	constructor(column, dimension, cube) {
		this.cube = cube;
		for (const key in column) {
			this[key] = column[key];
		}
		this.dimension = dimension;
	}

	finish() {
		this.related_dimension = this.cube.dimensions[this.related_dimension];
	}
	toJSON() {
		return this.path;
		// return {
		// 	'name': this.name,
		// 	'col_name': this.col_name,
		// 	'dimension': this.dimension.path,
		// 	'related_dimension': this.related_dimension?.path,
		// 	'is_pk': this.is_pk,
		// 	'type': this.type,

		// }
	}

}

class Measure {
	constructor (measure, dimension, cube) {
		this.cube = cube;
		for (const key in measure) {
			this[key] = measure[key];
		}
		this.dimension = dimension;
	}

	finish() {
	}

	toJSON() {
		return this.path;
	}

	toDict() {
		return {
			'class': this.class,
			'id': this.id,
			'col_name': this.col_name,
			'path': this.path,
			'expression': this.expression,
			'aggfunc': this.aggfunc,
			'description': this.description,
			'dimension': this.dimension.tbl_name,
		}
	}


}


class Dimension {
	constructor(dimension, cube) {
		this.cube = cube;
		for (const key in dimension) {
			this[key] = dimension[key];
		}
		this.properties = Object.fromEntries(
			Object.entries(this.properties).map(([key, value]) => [key, new Column(value, this, cube)])
		);
		if (this.type === 'measure') {
			this.measures = Object.fromEntries(
				Object.entries(this.measures).map(([key, value]) => [key, new Measure(value, this, cube)])
			);
			this.columns = {...this.measures, ...this.properties};
		}
		else {
			this.columns = this.properties;
		}
		
		this.pk = Object.values(this.columns).find(column => column.is_pk);
		Object.values(this.columns).forEach(column => {
			const special_types = [
				'measure_name', 
				'measure_formula',
				'measure_agg',
				'measure_value',
				'description',
				'user_created',
				'date_created',
				'company',
				'user_modified',
				'date_modified', 
			]
			if (special_types.includes(column.type)) {
				this[column.type] = column;
			}
		})
				

	}

	finnish() {
		Object.values(this.columns).forEach(column => {
			column.finish();
		})
		
		this.children = this.children.map(childDim => this.cube.dimensions[childDim]);
	}

	


	toJSON() {
		return {
			path: this.path,
			tbl_name: this.tbl_name,
			name: this.name,
			columns: this.columns
		}
	}
}

class Cube {
	constructor(cube) {
		for (const key in cube) {
			this[key] = cube[key]; // id, name, dimensions
		}
		this.dimensions = Object.fromEntries(
			Object.entries(this.dimensions).map(([key, value]) => [key, new Dimension(value, this)])
		);
		Object.values(this.dimensions).forEach(value => value.finnish());
	}

	toJSON() {
		return {
			name: this.name,
			dimensions: this.dimensions
		}
	}

	searchPath(path) {
		if (path instanceof Column) return path;
		if (path instanceof Dimension) return path;
		const [tbl_name, col_name] = path.split('.');
		const dimension = this.dimensions[tbl_name];
		if (!dimension) throw new Error(`Dimension ${tbl_name} not found`);
		const column = dimension.columns[col_name];
		if (!column) throw new Error(`Column ${tbl_name}.${col_name} not found`);
		return column;
	}

	parseQuery(query) {
		let { measures, columns, filters } = query;
		if (filters) {
			filters = filters.map(filter => {
				return {
					member: this.searchPath(filter.member),
					operator: filter.operator,
					value: filter.value,
				}
			})
		}
		if (measures) measures = measures.map(measure => this.search(measure));
		if (columns) columns = columns.map(column => this.search(column));
		return {...query, measures, columns, filters,  };
	}

	async getMeta(query){
		// Return a path to obj dict
		// return Object.fromEntries(
		// 	[...query.measures, ...query.columns, ...query.filters.map(filter => filter.member)]
		// 	.map(async name => [name, await this.search(name)])
		// );

		const meta = {};
		const paths = [...query.measures, ...query.columns, ...query.filters.map(filter => filter.member)];
		for (const path of paths) {
			meta[path] = await this.search(path);
		}
		
		return meta;
	}

	async query(query){
		const db = new Auth();
		const response = await db.fetch(`/cube/v1/query/${this.id}`, {
			method: 'POST',
			body: JSON.stringify({
				query: query,
				params: {}
			})
		});
		const result = await response.json();
		return result;
	}


	async search(path) {
		// Search for a measure or property by path
		const [tbl_name, col_name] = path.split('.');
		const dimension = this.dimensions[tbl_name];
		if (!dimension) return null;
		const column = dimension.columns[col_name];
		const measure = dimension.measures[col_name];
		if (!column && !measure) return null;
		return column || measure;
	}
	async copyData(sourceQuery, destinationQuery, value_modifying_expression, consolidate) {
		const db = new Auth();
		const response = await db.fetch(`/cube/v1/copy_fact_rows/${this.id}`, {
			method: 'POST',
			body: JSON.stringify({
				source_query: sourceQuery,
				destination_query: destinationQuery,
				value_modifying_expression,
				consolidate
			})
		});
		if (!response.ok) {
			const errorText = await response.text();
			alert(`Error copying data: ${errorText}`);
			throw new Error(`Error copying data: ${errorText}`);
		}
		const result = await response.json();
		return result;
	}

	async deleteData(query) {
		const db = new Auth();
		const response = await db.fetch(`/cube/v1/delete_fact_rows/${this.id}`, {
			method: 'POST',
			body: JSON.stringify({
				query: query
			})
		});
		if (!response.ok) {
			const errorText = await response.text();
			alert(`Error deleting data: ${errorText}`);
			throw new Error(`Error deleting data: ${errorText}`);
		}
		const result = await response.json();
		return result;
	}

	getMeasurePaths() {
		const measure_dims = Object.values(this.dimensions).filter(dim => dim.type === 'measure');
		const measures = measure_dims.map(dim => Object.values(dim.measures)).flat();
		return measures.map(measure => measure.path);
	}
	getColumnPaths() {
		const columns = Object.values(this.dimensions).map(dim => Object.values(dim.properties)).flat();
		return columns.map(column => column.path);
	}
		
}

const state = {
	cubes: {},
	queries: {}
};

const mutations = {
	SET_MODEL(state, { cubeId, cube }) {
		state.cubes = {
			...state.cubes,
			[cubeId]: new Cube(cube)
		};
	},
	UPDATE_MODEL(state, { cubeId, cube }) {
		if (state.cubes[cubeId]) {
			state.cubes = {
				...state.cubes,
				[cubeId]: new Cube(cube)
			};
		}
	},
	SET_QUERY(state, { query, output }) {
		state.queries = {
			...state.queries,
			[JSON.stringify(query)]: output
		};
	}
};

const actions = {
	async fetchCube({ state, commit }, cubeId) {
		if (!state.cubes[cubeId]) {
			// try {
				const db = new Auth();
				const response = await db.fetch(`/cube/crud/schema/${cubeId}`);
				const cube = await response.json();
				commit('SET_MODEL', { cubeId, cube });
		} 
		// Assert cube is in store
		if (!state.cubes[cubeId]) {
			throw new Error(`Cube ${cubeId} not found in store`);
		}
	},
	async updateCube({ commit }, cubeId) {
		try {
			const db = new Auth();
			const response = await db.fetch(`/cube/crud/schema/${cubeId}`);
			const cube = await response.json();
			commit('UPDATE_MODEL', { cubeId, cube });
		} catch (error) {
			console.error('Error updating cube:', error);
		}
	},
	async query({ state, commit }, { query }) {
		const query_json = JSON.stringify(query);
		if (state.queries[query_json]) {
			return state.queries[query_json];
		}
		let cube = state.cubes[query.model_id];
		if (!cube) {
			const db = new Auth();
			const response = await db.fetch(`/cube/crud/schema/${query.model_id}`);
			cube = await response.json();
			commit('UPDATE_MODEL', { cubeId: query.model_id });
		}
		const output = cube.query(query);
		commit('SET_QUERY', { query, output });
		return output;
	}

};	

const getters = {
	getCube: (state) => (cubeId) => {
		if (!state.cubes[cubeId]) {
			throw new Error(`Cube ${cubeId} not found`);
		}
		return state.cubes[cubeId];
	},
	getQuery: (state) => (query) => {
		const cube = state.cubes[query.model_id];
		return cube.parseQuery(query);
	},
	searchInCube: (state) => async (cubeId, path) => {
		const waitForCube = async (maxWaitMs = 10000) => {
		const startTime = Date.now();
		while (!state.cubes[cubeId]) {	
			if (Date.now() - startTime > maxWaitMs) {
			throw new Error(`Timeout: Cube ${cubeId} not found in store after ${maxWaitMs / 1000} seconds`);
			}
			await new Promise(resolve => setTimeout(resolve, 100)); // Wait 100ms before checking again
		}
	
		return state.cubes[cubeId];
		};
	
		const cube = await waitForCube();
		return cube.search(path);
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
